import { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import css from './index.module.css';

import SEO from "@components/seo";
import MainContent from "@components/content";
import MiniProduct from "@components/miniProduct";

import * as Types from '../../types';
import Search from "@components/search";

export default function Catalog() {
  const { id } = useParams();
  const [category, setCategory] = useState<Types.Category>();
  const [products, setProducts] = useState<Types.Product[]>();

  const [limit, _] = useState(51);
  const [start, setStart] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get(`${import.meta.env.VITE_API_URL}/products/c/${id}?limit=${limit}&start=${start}`, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      if (start === 0) {
        setProducts(response.data);
      } else {
        setProducts((prevProducts: any) => [...prevProducts, ...response.data]);
      }
      setLoading(false);
    }).catch(error => {
      console.log(error);
      setLoading(false);
    });

    axios.get(`${import.meta.env.VITE_API_URL}/categories/${id}`, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).then(response => {
      setCategory(response.data);
    }).catch(error => {
      console.log(error);
    });
  }, [id,  limit, start]);
  
  const handleScroll = useCallback((e: any) => {
    const bottom = e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight;
    if (bottom && !loading) {
      setLoading(true);
      setStart((prevStart) => prevStart + limit);
    }
  }, [loading, limit]);

  useEffect(() => {
    const container = document.getElementById('productListContainer');
    if (container) {
      container.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll]);


  return (
    <MainContent header={`n`}> 
      <SEO 
        title={`${category?.name}`}
        description={`${category?.miniDesc}`}
        ogImage={`${category?.coverImg}`}
        ogUrl={`${category?.linkCover}`}
      />

      <div className={css.header}>
        <h1>{category?.name}</h1>
        <Search />
      </div>

      <div className={css.productList}>
        {products?.map((product: Types.Product) => (
          <MiniProduct 
            id={product.id}
            product={product}
            title={product.name}
            price={product.price}
            image={product.images[0]}
            unit={product.unit}
            quantity={product.quantity}
          />
        ))}

        {loading && <div>загружаем...</div>}
      </div>
    </MainContent>
  )
}